import React from 'react';
import { AiOutlineInstagram, AiOutlineTwitter, AiOutlineYoutube } from 'react-icons/ai';

const PlatformIconRender = ({ platform, size, username }, props) => {
  switch (platform) {
  case 'youtube':
    return <span><AiOutlineYoutube color="#FF0000"
      cursor={'pointer'}
      onClick={() => username && window.open(`https://www.youtube.com/user/${username}`)}
      size={size}
      {...props}/></span>;
  case 'twitter':
    return <span><AiOutlineTwitter color="#1DA1F2"
      cursor={'pointer'}
      onClick={() => username && window.open(`https://twitter.com/${username}`)}
      size={size}
      {...props} /></span>;
  case 'instagram':
    return <span>
      <AiOutlineInstagram color="#dd2a7b"
        cursor={'pointer'}
        onClick={() =>username && window.open(`https://www.instagram.com/${username}`)}
        size={size}
        {...props} />
    </span>;
  default:
    return null;
  }
};

export default PlatformIconRender;
